<mat-form-field class="flex grow" subscriptSizing="dynamic">
  <mat-label>{{ label() }}</mat-label>
  <input
    type="text"
    matInput
    [formControl]="dataPointCtrl"
    [matAutocomplete]="auto"
  />

  @if (dataPointCtrl.value) {
    <button
      mat-icon-button
      matSuffix
      matTooltip="Clear selected {{ label() }}"
      (click)="clear()"
    >
      <mat-icon> close </mat-icon>
    </button>
  }
  <mat-autocomplete
    #auto="matAutocomplete"
    class="!p-0"
    [displayWith]="displayFn"
    (optionSelected)="optionSelected($event)"
  >
    <div class="flex flex-col bg-white">
      @for (group of filteredGroups$ | async; track group.label) {
        <div
          class="sticky top-0 z-10 flex bg-gray-50 p-2 text-xs font-semibold text-gray-500"
        >
          {{ group.label }}
        </div>
        @for (dataPoint of group.options; track dataPoint.value) {
          <mat-option class="!min-h-[36px] w-full" [value]="dataPoint">
            <div class="flex flex-row items-center gap-2">
              <mat-icon
                fontSet="material-symbols-outlined"
                class="icon-xs !m-0 opacity-50"
              >
                {{ dataPoint.icon }}
              </mat-icon>
              <div class="flex min-w-[200px]">
                {{ dataPoint.label }}
              </div>
              <div
                class="grow truncate text-xs opacity-50"
                [matTooltip]="dataPoint.description"
              >
                {{ dataPoint.description }}
              </div>
            </div>
          </mat-option>
        } @empty {
          <div class="p-2 text-xs opacity-50">No Available Datapoints</div>
        }
      } @empty {
        <div class="p-2 text-xs opacity-50">No Available Datapoints</div>
      }
    </div>
  </mat-autocomplete>
</mat-form-field>
